import { useState, useRef } from 'react'
import { Edit3 } from 'lucide-react'
import { Badge } from '../ui/badge'
import { Label } from '../ui/label'
import { TagEditor } from './TagEditor'
import { useClickOutside } from '../../hooks/useClickOutside'
import { labelStyle, badgeStyle, valueStyle } from '../../styles/typography'

interface InlineEditTagsProps {
  tags: string[]
  onChange: (tags: string[]) => void
  className?: string
}

export function InlineEditTags({
  tags = [],
  onChange,
  className = ''
}: InlineEditTagsProps) {
  const [isEditing, setIsEditing] = useState(false)
  const wrapperRef = useRef<HTMLDivElement>(null)

  useClickOutside(wrapperRef, () => setIsEditing(false), isEditing)

  if (isEditing) {
    return (
      <div className={className} ref={wrapperRef}>
        <TagEditor
          tags={tags}
          onChange={onChange}
          isEditable={true}
        />
      </div>
    )
  }

  // Display mode (click to edit)
  return (
    <div
      className={`group cursor-pointer ${className}`}
      onClick={() => setIsEditing(true)}
    >
      <Label style={labelStyle}>
        Tags
      </Label>
      <div className="flex items-center gap-2 mt-1">
        {tags.length > 0 ? (
          <div className="flex flex-wrap gap-2">
            {tags.map(tag => (
              <Badge key={tag} variant="outline" style={badgeStyle}>
                {tag}
              </Badge>
            ))}
          </div>
        ) : (
          <span
            className="text-gray-400 italic"
            style={valueStyle}
          >
            Click to add tags...
          </span>
        )}
        <Edit3 className="h-3.5 w-3.5 text-gray-300 opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0" />
      </div>
    </div>
  )
}
